import React, { useState, useRef, useContext } from "react";
import styled from "styled-components";
import { rem } from "polished";
import anime from "animejs";
import mq from "../../helpers/media-queries";
import Bottom from "../Bottom/Bottom";
import { getLocalStorage, setLocalStorage } from "../../helpers/local-storage";

const Container = styled.div`
  ${mq("sm", "min")} {
    width: ${rem(420)};
    flex-shrink: 0;
    height: 100%;
    display: flex;
    background: #fff;
    flex-direction: column;
    box-shadow: -4px 10px 14px rgba(0, 0, 0, 0.04);
    position: relative;
    z-index: 10;
    border-left: 1px solid #eaeaea;
  }
`;

const Content = styled.div`
  ${mq("sm", "max")} {
    padding: ${rem(17)};
  }

  ${mq("sm", "min")} {
    padding: ${rem(40)};
    flex: 1;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
  }
`;

const SidebarContainer = ({
  sections,
  isSubmitDisabled,
  totalPrice,
  children,
  onAddToCart,
  name,
    title
}) => {
  const [activeSection, setActiveSection] = useState(getLocalStorage(name, 0));
  const ContainerRef = useRef(null);

const goToSection = (section) => {
  setLocalStorage(name, section)
    setActiveSection(section);
}

  const nextStep = () => {
    anime({
      targets: ContainerRef.current,
      scrollTop: 0,
      easing: "cubicBezier(0.85, 0, 0.15, 1)",
      duration: 750,
    });

    anime({
      targets: document.querySelectorAll("html, body"),
      scrollTop: 0,
      easing: "cubicBezier(0.85, 0, 0.15, 1)",
      duration: 750,
    });

    goToSection(activeSection + 1);
  };

  return (
      <Container>
          <Content ref={ContainerRef}>
              {children(activeSection, goToSection)}
          </Content>
          <Bottom
              title={title}
              isOverview={activeSection === sections.length}
              nextStep={nextStep}
              nextTitle={
                  activeSection < sections.length - 1
                      ? sections[activeSection + 1].title
                      : "Overview"
              }
              isDisabled={isSubmitDisabled(sections[activeSection]?.name)}
              totalPrice={totalPrice}
              onAddToCart={onAddToCart}
          />
    </Container>
  );
};

export default SidebarContainer;
